import { toaster } from '@/components/ui/toaster';
import { mcpCopublicityKeys } from '@/hooks/queries/use-mcp-copublicity-query';
import api from '@/libs/axiosInstance';
import type {
  ApiResponse,
  McpCopublicityApprovalRequest,
  McpCopublicityApprovalResponse,
} from '@fluenceur/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

export function useMcpCopublicityApprovalAction(id: string) {
  const client = useQueryClient();
  const { t } = useTranslation();
  return useMutation<
    McpCopublicityApprovalResponse,
    AxiosError<ApiResponse>,
    McpCopublicityApprovalRequest
  >({
    mutationFn: async (payload) => {
      const response = await api.post<ApiResponse<McpCopublicityApprovalResponse>>(
        `/mcp/copublicity/preparations/${id}/approve`,
        payload
      );
      if (!response.data.data) throw new Error('Approval unavailable');
      return response.data.data;
    },
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: mcpCopublicityKeys.review(id) });
      toaster.success({ title: t('mcp.copublicity.accepted') });
    },
    onError: (error) =>
      toaster.error({
        title: t('common.error'),
        description:
          error.response?.data?.message ||
          t(
            error.response?.data?.code === 'E_MCP_REVIEW_CHANGED'
              ? 'mcp.copublicity.reviewChanged'
              : 'mcp.copublicity.approvalFailed'
          ),
      }),
  });
}
